import { render } from "./UserEditHeaderUserName.vue?vue&type=template&id=9fa320c2&scoped=true&ts=true"
import script from "./UserEditHeaderUserName.vue?vue&type=script&lang=ts"
export * from "./UserEditHeaderUserName.vue?vue&type=script&lang=ts"

import "./UserEditHeaderUserName.vue?vue&type=style&index=0&id=9fa320c2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa320c2"]])

export default __exports__